type AccordionOptions = {
    selector?: string;
    groupSelector?: string;
    duration?: number;
    easing?: string;
    root?: ParentNode;
};
export class AccordionAnimator {
    private duration: number;
    private easing: string;
    private selector: string;
    private groupSelector: string;
    private root: ParentNode;
    constructor(options: AccordionOptions = {}) {
        this.selector = options.selector || ".accordion";
        this.groupSelector = options.groupSelector || ".accordion-group";
        this.duration = options.duration || 300;
        this.easing = options.easing || "ease";
        this.root = options.root || document;
        this.init();
    }

    private init() {
        const accordions = this.root.querySelectorAll<HTMLDetailsElement>(this.selector);

        accordions.forEach((el) => {
            const summary = el.querySelector("summary");
            if (!summary) return;

            const content = Array.from(el.children).find(
                (child) => child !== summary
            ) as HTMLElement;

            if (!content) return;

            if (!el.open) content.style.height = "0px";

            summary.addEventListener("click", (e) => {
                e.preventDefault(); // Prevent native toggle
                this.toggle(el, content);
            });
        });

        this.initFaqShowMoreToggles();
    }

    private initFaqShowMoreToggles() {
        const toggleButtons = this.root.querySelectorAll<HTMLButtonElement>("[data-faq-show-more]");

        toggleButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const accordionGroup = button.closest(this.groupSelector);
                const moreItems = accordionGroup?.querySelector<HTMLElement>("[data-faq-more-items]");
                const labelMore = button.querySelector<HTMLElement>("[data-faq-label-more]");
                const labelLess = button.querySelector<HTMLElement>("[data-faq-label-less]");

                if (!moreItems) return;

                const isHidden = moreItems.classList.contains("hidden");
                moreItems.classList.toggle("hidden");

                if (labelMore && labelLess) {
                    labelMore.classList.toggle("hidden", isHidden);
                    labelLess.classList.toggle("hidden", !isHidden);
                }
            });
        });
    }

    private toggle(el: HTMLDetailsElement, content: HTMLElement) {
        const isOpening = !el.open;
        const group = el.closest(this.groupSelector);
        const selfClosingAttr = group?.getAttribute("data-self-closing");
        const selfClosing = selfClosingAttr === "true";

        if (isOpening && selfClosing && group) {
            const others = group.querySelectorAll<HTMLDetailsElement>(this.selector);
            others.forEach((otherEl) => {
                if (otherEl !== el && otherEl.open) {
                    const otherContent = Array.from(otherEl.children).find(
                        (child) => child !== otherEl.querySelector("summary")
                    ) as HTMLElement;

                    if (otherContent) this.close(otherEl, otherContent);
                }
            });
        }

        if (isOpening) {
            this.open(el, content);
        } else {
            this.close(el, content);
        }
    }

    private open(el: HTMLDetailsElement, content: HTMLElement) {
        el.open = true;
        const startHeight = 0;
        const endHeight = content.scrollHeight;

        content.animate(
            [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
            {
                duration: this.duration,
                easing: this.easing,
            }
        ).onfinish = () => {
            content.style.height = "auto";
        };
    }

    private close(el: HTMLDetailsElement, content: HTMLElement) {
        const startHeight = content.scrollHeight;

        const animation = content.animate(
            [{ height: `${startHeight}px` }, { height: "0px" }],
            {
                duration: this.duration,
                easing: this.easing,
            }
        );

        animation.onfinish = () => {
            el.open = false;
            content.style.height = "0px";
        };
    }
}